import React, { Fragment, useContext } from 'react';

import { PhoneInput as InputField } from 'formlabs-web-components/Form';
import { FormContext } from './Form';

const PhoneInput = ({
  name,
  value,
  label,
  isRequired,
  placeholder,
  hideLabel
}) => {
  const { formName, invalidFields } = useContext(FormContext);
  const id = `${formName}_phone_${name}`;
  const hasError = invalidFields.includes(name);

  return (
    <Fragment>
      {label && !hideLabel ? (
        <label aria-hidden="true" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <InputField
        id={id}
        name={name}
        value={value || ''}
        required={isRequired}
        placeholder={placeholder}
        hasError={hasError}
        aria-label={label}
      />
    </Fragment>
  );
};

export default PhoneInput;
